<ng-template [ngIf]="isValidOrderEvent()">
	<div
		class="event-container"
		[ngClass]="{ 'cursor-default': orderEvent.event !== 'order.created' }"
		(click)="openEvent(orderEvent)"
	>
		<div class="event-data data-creation">
			<div class="event-author">
				<span class="badge badge-primary" *ngIf="orderEvent.status === 'new'">
					NEW
				</span>
				{{ orderEvent.data['user']['fullName'] }}
			</div>
			<div class="event-time">{{ getTimeFrom(orderEvent.timestamp) }}</div>
		</div>
		<div>
			<span class="event-type">{{ getNotificationMessage() }}</span>
		</div>
		<div class="event-data data-fields">
			<div class="field">
				Reference ID:
				<span>{{ orderEvent.data['externalId'] || orderEvent.data['externalTrackingId'] }}</span>
			</div>
			<div class="field">
				Schema: <span>{{ orderEvent.data['schema'] }}</span>
			</div>
		</div>
	</div>
	<hr />
</ng-template>
